import {
  CREATE_COUPON_FAIL,
  CREATE_COUPON_REQUEST,
  CREATE_COUPON_SUCCESS,
  GETALL_COUPON_FAIL,
  GETALL_COUPON_REQUEST,
  GETALL_COUPON_SUCCESS,
  GET_COUPON_FAIL,
  GET_COUPON_REQUEST,
  GET_COUPON_SUCCESS,
  GET_COUPON_RESET,
  UPDATE_COUPON_FAIL,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_SUCCESS,
  DELETE_COUPON_FAIL,
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_SUCCESS
} from "./couponTypes";

export const couponReducer = (state = {}, action) => {
  switch (action.type) {
    // REQUEST
    case GETALL_COUPON_REQUEST: {
      return { ...state, loading: true };
    }
    case GET_COUPON_REQUEST: {
      return { ...state, loading: true};
    }
    case CREATE_COUPON_REQUEST: {
      return { ...state, loading: true };
    }
    case UPDATE_COUPON_REQUEST: {
      return { ...state, loading: true};
    }

    case DELETE_COUPON_REQUEST: {
      return { ...state, loading: true };
    }

    // LIST
    case GETALL_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        allcoupons: action.payload,
      };

    case CREATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case GET_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupon: action.payload,
      };

    case GET_COUPON_RESET:
      return {
        ...state,
        loading: false,
        coupon: {},
      };

    case UPDATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupon: action.payload,
        success: true,
      };
     
      case DELETE_COUPON_SUCCESS:
        return {
          ...state,
          loading: false,
          coupon: action.payload,
        }; 

    // FAILED
    case GETALL_COUPON_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_COUPON_FAIL:
      return { ...state, loading: false, error: action.payload };
         
      case DELETE_COUPON_FAIL:
        return { ...state, loading: false, error: action.payload };

    case GET_COUPON_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CREATE_COUPON_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
